import type { FC } from 'react';
import { publicLink } from 'src/common/const';
import { PRODUCT_ALL_NAME } from 'src/const/title';
import { isFlowUsApp } from 'src/utils/electron-util';
import { Logo } from 'src/views/share/logo';

interface Props {
  hideAllLink?: boolean;
}

export const Header: FC<Props> = (props) => {
  if (isFlowUsApp.check) return <div className="h-11 fixed left-0 top-0 w-screen" />;

  if (__PRIVATE__) return null;

  return (
    <div className={'w-full px-12 pt-8 flex items-center justify-between sm:px-5'}>
      <div className="flex items-center cursor-default">
        <Logo className="pointer-events-none m-0" />
        <span className="text-h2" hidden={__BUILD_IN__}>
          <span className="font-normal ml-5 sm:hidden">{PRODUCT_ALL_NAME}</span>
        </span>
      </div>
      {!props.hideAllLink && (
        <div className="flex text-t1-medium">
          <a hidden={__BUILD_IN__} href={publicLink.appDownload}>
            下载
          </a>
          <a href={publicLink.product} className="mx-5">
            进入官网
          </a>
          <a href={publicLink.helpCenter}>帮助中心</a>
        </div>
      )}
    </div>
  );
};
